import { render, staticRenderFns } from "./ExpenseAllowanceSingle.vue?vue&type=template&id=2dd66fae&scoped=true"
import script from "./ExpenseAllowanceSingle.vue?vue&type=script&lang=js"
export * from "./ExpenseAllowanceSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd66fae",
  null
  
)

export default component.exports